export const environment = {
  production: true,
  homeurl: '/wp-json/home/v1/',
  workurl: '/wp-json/work/v1/',
  mainUrl: '/wp-json/wp/v2/',
  menuurl: '/wp-json/menus/v1/menus/',
};